import React, { useEffect } from 'react';
import Icon from '../AppIcon';
import { useError } from '../../contexts/ErrorContext';

const ErrorNotification = () => {
  const { error, clearError } = useError();

  useEffect(() => {
    if (error) {
      // Auto-dismiss after 5 seconds if not already set
      const timer = setTimeout(() => {
        clearError();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [error, clearError]);

  if (!error) return null;

  return (
    <div className="fixed top-4 right-4 z-[9999] animate-slide-down">
      <div className="bg-error/95 text-error-foreground rounded-lg shadow-warm-lg p-4 min-w-[300px] max-w-[500px] border border-error/20">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-0.5">
            <Icon name="AlertCircle" size={20} color="var(--color-error-foreground)" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-error-foreground break-words">
              {error.message}
            </p>
          </div>
          <button
            onClick={clearError}
            className="flex-shrink-0 p-1 rounded hover:bg-error/20 transition-smooth"
            aria-label="Dismiss error"
          >
            <Icon name="X" size={16} color="var(--color-error-foreground)" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorNotification;
